import axios from 'axios'
const API_URL = `${process.env.REACT_APP_API_URL}`;

export const updateProfile = (data, callback) => {
    axios.post(`${API_URL}/api/users/update_profile`, data).then((response) => {
        callback(response.data)
    }).catch((error) => {
    
    });
}